import { EdgeDeviceTypes } from "./EdgeDeviceConstants";

const LOCAL_PICTUREPOOL_BASE_URL = "/app/id/images/picturepool";
const PORTAL_PICTUREPOOL_BASE_URL =
  "https://portal.endress.com/webapp/picturepool";

const buildLocalPicturePoolUrl = (size: number, imageName: string): string =>
  `${LOCAL_PICTUREPOOL_BASE_URL}/${size}/0/${imageName}`;

const buildPortalPicturePoolUrl = (size: number, imageName: string): string =>
  `${PORTAL_PICTUREPOOL_BASE_URL}/${size}/0/${imageName}`;

export const getEdgeDeviceImageUrl = (
  edgeDeviceCode: string,
  size: number,
): string | undefined => {
  switch (edgeDeviceCode) {
    case EdgeDeviceTypes.SGC500_AA:
      return buildLocalPicturePoolUrl(size, "SGC500-AA.jpg");
    case EdgeDeviceTypes.SGC500_AB:
    case EdgeDeviceTypes.SGC500_AB_24:
      return buildLocalPicturePoolUrl(size, "SGC500-AB.jpg");
    case EdgeDeviceTypes.SGC500_AC:
      return buildLocalPicturePoolUrl(size, "SGC500-AC.jpg");
    case "SGC400":
      return buildPortalPicturePoolUrl(size, "SGC400.jpg");
    case EdgeDeviceTypes.SGC200:
      return buildPortalPicturePoolUrl(size, "SGC200.jpg");
    default:
      return undefined;
  }
};

export const getFieldGatewayImageUrl = (
  fieldGatewayCode: string,
  size: number,
): string | undefined => {
  switch (fieldGatewayCode) {
    case "cm44modbustcp":
      return buildPortalPicturePoolUrl(size, "CM444.jpg");
    case "nxa820":
      return buildPortalPicturePoolUrl(size, "NXA820.jpg");
    case "sfg250":
      return buildPortalPicturePoolUrl(size, "SFG250.jpg");
    case "sfg500":
      return buildPortalPicturePoolUrl(size, "SFG500.jpg");
    case "swg50":
      return buildPortalPicturePoolUrl(size, "SWG50.jpg");
    case "swg70":
      return buildPortalPicturePoolUrl(size, "SWG70.jpg");
    default:
      return undefined;
  }
};
